<template>
    <div v-if="internalValue">
         <span class="progress" v-bind:class="{'in-progress':internalValue.total_sent<internalValue.total_audience}" v-if="!internalValue.is_cancelled">
            <label>{{ internalValue.total_audience ? parseInt(internalValue.total_sent * 100 / internalValue.total_audience) : 100 }}%</label>
            <span :style="{width: (internalValue.total_sent * 100 / internalValue.total_audience) + 'px'}"></span>
        </span>
        <span class="progress" v-bind:class="{'cancelled':internalValue.is_cancelled}" v-if="internalValue.is_cancelled">
            <label>Annulé à {{ parseInt(internalValue.total_sent * 100 / internalValue.total_audience) }}%</label>
        </span>
        <button @click="cancelPublication()" v-if="!internalValue.is_cancelled && (internalValue.total_sent<internalValue.total_audience)">Annuler</button>
    </div>
</template>
<script>

    import CampaignPublicationService from './CampaignPublicationService.js';

    export default {
        name: 'CampaignPublicationService',
        props: ['id'],
        data: function () {
            return {
                internalValue: null,
                interval: null
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.interval = setTimeout(this.updateProgress, 0)
        },
        methods: {
            cancelPublication: function(){
                var confirm = window.confirm("Souhaitez-vous annuler l'envoi ?")
                if(confirm){
                    clearInterval(this.interval)
                    CampaignPublicationService.cancelProgression(this.id).then((response) => {
                        console.log("cancel", response.data)
                    }).catch((response) => {
                        console.log("error", response);
                    })
                }
            },
            updateProgress: function(){
                clearInterval(this.interval)
                CampaignPublicationService.getProgression(this.id).then((response) => {
                    console.log("publication", response.data)
                    this.internalValue = response.data
                    if( this.internalValue.total_sent < this.internalValue.total_audience && this.internalValue.is_cancelled == null)
                    {
                        this.interval = setTimeout(this.updateProgress, 2000)
                    }
                }).catch((response) => {
                    console.log("error", response);
                })
            }
        },
        beforeDestroy: function () {
            clearInterval(this.interval)
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/campaign/campaign/CampaignProgressWidget.vue